import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '~/core/core.module';
import { FollowUpTask, TaskStatus } from '~/repositories/followup/store/followup.models';

@Injectable({
  providedIn: 'root'
})
export class FollowupService {
  constructor(private readonly http: HttpClient) {}

  fetchFollowupTasksForDecree(decreeId: string): Observable<FollowUpTask[]> {
    return this.http.get<FollowUpTask[]>(`${environment.BACKEND_URL}/follow-up-tasks/objectmeta/${decreeId}`);
  }

  publishFollowupTask(followup: FollowUpTask, objectMetaId: string): Observable<FollowUpTask> {
    return this.http.post<FollowUpTask>(
      `${environment.BACKEND_URL}/follow-up-tasks/objectmeta/${objectMetaId}`,
      followup
    );
  }

  updateFollowupStatus(taskIds: string[], status: TaskStatus, additionalInfo: string): Observable<FollowUpTask[]> {
    return this.http.put<FollowUpTask[]>(`${environment.BACKEND_URL}/follow-up-tasks/status`, {
      taskIds,
      status,
      additionalInfo
    });
  }

  assignTasks(taskIds: string[], assignedUserId: string): Observable<FollowUpTask[]> {
    return this.http.put<FollowUpTask[]>(`${environment.BACKEND_URL}/follow-up-tasks/assign`, {
      taskIds,
      assignedUserId
    });
  }

  updateFollowupTask(objectMetaId: string, followupTask: FollowUpTask): Observable<FollowUpTask> {
    return this.http.put<FollowUpTask>(`${environment.BACKEND_URL}/follow-up-tasks/${objectMetaId}`, {
      ...followupTask
    });
  }

  deleteFollowupTask(decreeId: string): Observable<void> {
    return this.http.delete<void>(`${environment.BACKEND_URL}/follow-up-tasks/${decreeId}`);
  }

  isAllowedToAddFollowupTasks(decreeId: string): Observable<boolean> {
    return this.http.get<boolean>(`${environment.BACKEND_URL}/follow-up-tasks/objectmeta/${decreeId}/allowed-to-add`);
  }
}
